import styled, { css, keyframes } from 'styled-components'

import { ButtonWrapper } from '@/components/Button/Button.styles'

const barCodeAnimation = keyframes`
  0% { top: 0; opacity: 0; }
  30% { top: 0; opacity: 0; }
  50% {  opacity: 0.4; }
  70% { top: 100%; opacity: 0; }
  100% { top: 100%; opacity: 0; }
`

export const ScannerLogo = styled.div`
  margin: 0vh auto 2rem;
  img {
    height: 4rem;
  }
`

export const ScannerIndicatorIcon = styled.div`
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 6.5rem;
  height: 5rem;
  margin-bottom: 1rem;

  &:after {
    position: absolute;
    top: 0;
    height: 2px;
    left: 0;
    right: 0;
    content: ' ';
    background-color: currentColor;
    animation: ${barCodeAnimation} infinite 3s;
  }

  svg {
    display: block;
    width: 80%;
    height: 80%;
    fill: currentColor;
  }
`

export const ScannerIndicatorWrapper = styled.div`
  text-align: center;
  position: relative;

  h5 {
    font-size: 1rem;
    font-weight: 400;
    margin-bottom: 0;
  }

  ${props =>
    props.size === 'small' &&
    css`
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column-reverse;
      margin: 1rem auto;

      h5 {
        font-size: 0.85rem;
      }

      ${ScannerIndicatorIcon} {
        margin-bottom: 0;
        width: 2.5rem;
        height: 2rem;
        margin-top: 0.5rem;

        &:after {
          height: 1px;
        }
      }
    `};
`

export const ScannerFooter = styled.div`
  margin-top: 1rem;
  width: 100%;
  margin-bottom: 1rem;

  ${ButtonWrapper} {
    width: 100%;
    margin-bottom: 0.5rem;
  }
`

export const ScannerVendor = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: flex-end;
  text-align: center;

  span {
    display: block;
    color: var(--color-muted-inverted);
    font-weight: 500;
    margin-right: 0.5rem;
    font-size: 0.8rem;
  }

  img {
    height: 2rem;
  }
`

export const ScannerWrapper = styled.div`
  min-height: 100%;
  display: flex;
  flex-direction: column;
  width: 100%;

  ${ScannerIndicatorWrapper} {
    margin-top: auto;
    margin-bottom: auto;
  }
`
